import transactionsApiDefinition from './api.js';
import transactionsDefinition from './module.js';
const transactions = () => ({
    id: 'transactions',
    definitions: [
        { definition: transactionsDefinition },
        { definition: transactionsApiDefinition },
        {
            definition: {
                id: 'txSend',
                type: 'module',
                factory: ({ transactions }) => transactions.send,
                public: true,
                dependencies: ['transactions'],
            },
        },
    ],
});
export default transactions;
